import { create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';

type DeliveriesOrgStore = {
  selectedOrgId: number | null;
  setSelectedOrgId: (value: number | null) => void;
};

/**
 * Which organization the vDrive console (apps/deliveries) is managing.
 * Persisted so a reload keeps the context; every org-scoped query key carries
 * this id. Lives in the lib rather than the app because lib code needs it
 * too: the driver-chat transport addresses threads under the organization
 * and the sidebar badge counts that organization's unread messages.
 *
 * Version 2: the mock era stored string ids (`org-rest`); the backend's are
 * numbers, so an old value is dropped and the first organization is picked.
 */
export const useDeliveriesOrg = create<DeliveriesOrgStore>()(
  devtools(
    persist(
      (set) => ({
        selectedOrgId: null,
        setSelectedOrgId: (value) => set(() => ({ selectedOrgId: value })),
      }),
      {
        name: 'vg-deliveries-org',
        storage: createJSONStorage(() => localStorage),
        version: 2,
        migrate: () => ({ selectedOrgId: null }),
      }
    ),
    { name: 'deliveriesOrg' }
  )
);
